import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const {
        setAuth,
        getTenantIdFromUrl,
        tenantSessions,
        setAuthWithTenant,
        addOrUpdateTenantSession,
        permissions,
        role
    } = useAuth();

    const refresh = async () => {
        const currentTenant = tenantSessions[tenantSessions.length - 1];
        const tenantId = currentTenant.tenant_id || getTenantIdFromUrl();
        const response = await axios.get(`/refreshToken?tenant_id=${tenantId}`, {
            withCredentials: true,
        });

        const authData = response.data.data;

        if (tenantId) {
            // Use the new multi-tenant auth setter
            setAuthWithTenant(authData, tenantId);
        } else {
            // Fallback to legacy behavior
            setAuth(prev => {
                prev = authData;
                return prev;
            });
        }

        return authData.access_token;
    }
    return refresh;
};

export default useRefreshToken;
